<script setup lang="ts">
import { SpeckleIcon, SpeckleProjectSearch, useSpeckleNotificationsStore } from "@haskoning/vue-speckle";
import { computed, watch } from "vue";

const props = defineProps<{
  isSpeckleReady: boolean;
  isLoggingIn: boolean;
}>();

const emit = defineEmits<{
  login: [];
}>();

const projectPlaceholder = computed<string>(() =>
  props.isLoggingIn ? "Signing in to Speckle..." : "Login required to select project"
);

function requestLogin(): void {
  if (props.isLoggingIn) {
    return;
  }
  emit("login");
}

// TODO: remove this suppression once vue-speckle's notification store is fixed.
const LINKED_PROJECT_MESSAGE_PREFIX = "Linked Speckle project";

const speckleNotificationsStore = useSpeckleNotificationsStore();

watch(
  () => speckleNotificationsStore.visibility,
  (isVisible) => {
    if (!isVisible || !speckleNotificationsStore.message.startsWith(LINKED_PROJECT_MESSAGE_PREFIX)) {
      return;
    }

    speckleNotificationsStore.visibility = false;
  },
  { flush: "sync" }
);
</script>

<template>
  <SpeckleProjectSearch
    v-if="isSpeckleReady"
    label="Project"
    variant="filled"
    density="comfortable"
    bg-color="surfaceContainerHighest"
  />

  <v-text-field
    v-else
    label="Project"
    variant="filled"
    density="comfortable"
    bg-color="surfaceContainerHighest"
    hide-details
    readonly
    :placeholder="projectPlaceholder"
    append-inner-icon="mdi-login"
    :loading="isLoggingIn"
    role="button"
    tabindex="0"
    @click="requestLogin"
    @click:append-inner="requestLogin"
    @keydown.enter.prevent="requestLogin"
    @keydown.space.prevent="requestLogin"
  >
    <template #prepend>
      <v-icon>
        <SpeckleIcon />
      </v-icon>
    </template>
  </v-text-field>
</template>

<style scoped>
:deep(.v-field--variant-filled.v-field--focused .v-field__overlay) {
  opacity: 0;
}
</style>
